import React from "react";
import { PolicyFullObject } from "../../types/insurance.ts";
import SectionHeader from "../SectionHeader/SectionHeader.tsx";
import { inputClass, labelClass } from "../../constants/formStyles";

interface ClientFormProps {
  policyData: PolicyFullObject;
  setPolicyData: React.Dispatch<React.SetStateAction<PolicyFullObject>>;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleIdentifierBlur: () => void;
  handleSearch: () => void;
  handleClientSave: () => void;
}

const ClientForm: React.FC<ClientFormProps> = ({
  policyData,
  setPolicyData,
  handleChange,
  handleIdentifierBlur,
  handleClientSave,
}) => {
  return (
    <div className="mt-2">
      <fieldset className="border-stroke dark:border-strokedark shadow-default dark:bg-boxdark rounded-sm border bg-white">
        <SectionHeader title="Данни за клиент" />

        <div className="p-3 pt-1">
          <div className="grid grid-cols-4 gap-2 sm:grid-cols-8">
            <div className="col-span-2">
              <label className={labelClass}>ЕГН/Булстат</label>
              <input
                type="text"
                name="insuranceClientPin"
                value={policyData.insuranceClientPin || ""}
                onChange={(e) =>
                  setPolicyData((prevData) => ({
                    ...prevData,
                    insuranceClientPin: e.target.value,
                  }))
                }
                onBlur={handleIdentifierBlur}
                className={inputClass}
              />
            </div>
            <div className="col-span-2">
              <label className={labelClass}>Име</label>
              <input
                type="text"
                name="insuranceClientName"
                value={policyData.insuranceClientName || ""}
                onChange={handleChange}
                className={inputClass}
              />
            </div>
            <div className="col-span-2">
              <label className={labelClass}>Телефон</label>
              <input
                type="text"
                name="insuranceClientPhone"
                value={policyData.insuranceClientPhone || ""}
                onChange={handleChange}
                className={inputClass}
              />
            </div>
            <div className="col-span-2">
              <label className={labelClass}>Адрес</label>
              <input
                data-no-decimal-guard=""
                type="text"
                name="insuranceClientAddress"
                value={policyData.insuranceClientAddress || ""}
                onChange={handleChange}
                className={inputClass}
              />
            </div>
          </div>

          <button
            onClick={(e) => {
              e.preventDefault();
              handleClientSave();
            }}
            className="bg-primary mx-auto mt-4 flex w-1/3 justify-center rounded px-3 py-1.5 text-xs font-medium text-white hover:bg-opacity-90 sm:w-1/6"
          >
            Запис на клиент
          </button>
        </div>
      </fieldset>
    </div>
  );
};

export default ClientForm;
